import PaintCostOf1000DurstWg from '../../components/calculation-form/components/form-items/paint-cost-of-1000-durst-wg'
import { onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const paintCostOf1000DurstWGColumn: CalculationColumn = {
    dataIndex: 'paintCostOf1000DurstWG',
    title: 'Стоимость краски 1000 шт. Durst, WG',
    width: 100,
    editable: true,
    FormItem: <PaintCostOf1000DurstWg />,
    onCell: onAnyStandardCell,
}
